/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlZeroDayAlertUploadJobSummary } from './ControlZeroDayAlertUploadJobSummary';
import {
    ControlZeroDayAlertUploadJobSummaryFromJSON,
    ControlZeroDayAlertUploadJobSummaryFromJSONTyped,
    ControlZeroDayAlertUploadJobSummaryToJSON,
} from './ControlZeroDayAlertUploadJobSummary';

/**
 * 
 * @export
 * @interface ControlListZeroDayAlertUploadJobsResponse
 */
export interface ControlListZeroDayAlertUploadJobsResponse {
    /**
     * 
     * @type {Array<ControlZeroDayAlertUploadJobSummary>}
     * @memberof ControlListZeroDayAlertUploadJobsResponse
     */
    results: Array<ControlZeroDayAlertUploadJobSummary>;
}

/**
 * Check if a given object implements the ControlListZeroDayAlertUploadJobsResponse interface.
 */
export function instanceOfControlListZeroDayAlertUploadJobsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlListZeroDayAlertUploadJobsResponseFromJSON(json: any): ControlListZeroDayAlertUploadJobsResponse {
    return ControlListZeroDayAlertUploadJobsResponseFromJSONTyped(json, false);
}

export function ControlListZeroDayAlertUploadJobsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlListZeroDayAlertUploadJobsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(ControlZeroDayAlertUploadJobSummaryFromJSON)),
    };
}

export function ControlListZeroDayAlertUploadJobsResponseToJSON(value?: ControlListZeroDayAlertUploadJobsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(ControlZeroDayAlertUploadJobSummaryToJSON)),
    };
}

